<template>
    <div style="height: 100%;">
        <template v-if="isLoading">
            <ob-spinner loading-text="Loading..."></ob-spinner>
        </template>
        <template v-else>
            <folder-list v-if="showFolderList" :FormI539List="completeFormI539List" :consultantDetails="consultantDetails" ></folder-list>
            <Fromi539-intro :consultantDetails="consultantDetails" v-else></Fromi539-intro>
        </template>
    </div>
</template>
<script>
import FolderList from './FormI539/FolderList.vue'
import FormI539IntroPage from './FormI539/FormI539Intro.vue'
export default{
    props: ["consultantDetails"],
  data(){
      return{
          isLoading: true,
          showFolderList:false,
          completeFormI539List:[]
      }
  },
  components: {
             "Fromi539-intro": FormI539IntroPage,
             "folder-list": FolderList
    },
    computed:{
        EmployeeId() {
                return this.consultantDetails ? this.consultantDetails.EmployeeId : this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
        }
    },
    created() {
        let interval = setInterval(() => {
            if(this.EmployeeId && this.EmployeeId != '') {
                clearInterval(interval);
                this.fetchData();
            }
            }, 500);
        
        events.listen('LoadI539Details', () => {
            this.fetchData()
        })
    },
    methods: {
        fetchData(){
                this.isLoading= true
                ajax.get(`FormI539/Employee/${this.EmployeeId}`, {}, (res) => {
                    console.log(res)
                    if(res.data && res.data.length > 0)
                    {
                        this.showFolderList = true
                        this.completeFormI539List = res.data
                    }else
                    {
                        Object.keys(res.data).forEach(function(key) {
                        console.log(key, res.data[key]);
                        if(res.data[key] == 'NoRecordsFound'){
                            this.showFolderList = false
                        }
                        });
                    }
                    this.isLoading = false;
                    this.fetchH1BData()
                })
        },
        fetchH1BData(){ 
                ajax.get(`H1B/GetH1BListForI539?consultantId=${this.loggedInUserObj.consultantId}&organizationId=${this.loggedInUserObj.orgId}`, {}, (res) => {
                    if(res.data.State==true){ 
                        var List=res.data.H1BList.filter(c=>(c.H1BDisplayStatus != 'H-1B Denied' && c.H1BDisplayStatus != 'H-1B Withdrawn' && c.H1BDisplayStatus != 'H-1B CAP Case Rejected'))
                        var _that=this;
                        var x =  _that.completeFormI539List
                        x.forEach(element => {
                            if(element.workAuthorization != null && element.workAuthorization != '' && element.workAuthorization.referenceId != null)
                            {
                              var workAuth = List.find(x=>x.Id == element.workAuthorization.referenceId && x.H1BDisplayStatus != 'H-1B Denied' && x.H1BDisplayStatus != 'H-1B Withdrawn' && x.H1BDisplayStatus != 'H-1B CAP Case Rejected');
                              if(workAuth != null && workAuth != undefined)
                              {
                               if(element.workAuthorization.status == workAuth.H1BDisplayStatus
                                      && element.workAuthorization.checkListStatus == workAuth.CheckListStatus
                                      && element.workAuthorization.documentNumber == workAuth.DocumentNumber
                                      && moment(element.workAuthorization.petitionFiledDate.date).format('MM/DD/YYYY') == moment(workAuth.PetitionFiledDate).format('MM/DD/YYYY')
                                      && moment(element.workAuthorization.validFrom.date).format('MM/DD/YYYY') == moment(workAuth.IssueDate).format('MM/DD/YYYY')
                                      && moment(element.workAuthorization.validTo.date).format('MM/DD/YYYY') == moment(workAuth.ExpiryDate).format('MM/DD/YYYY')
                                    )
                                {
                                 // need to call a db update api for changed values
                                }
                                else
                                {
                                    element.workAuthorization.status = workAuth.H1BDisplayStatus;
                                    element.workAuthorization.checkListStatus = workAuth.CheckListStatus;
                                    element.workAuthorization.documentNumber = workAuth.DocumentNumber;
                                    element.workAuthorization.petitionFiledDate.date = moment(workAuth.PetitionFiledDate).format('MM/DD/YYYY')=="01/01/0001"  || moment(workAuth.PetitionFiledDate).format('MM/DD/YYYY')=="Invalid date"? '': moment(workAuth.PetitionFiledDate).format('MM/DD/YYYY');
                                    element.workAuthorization.validFrom.date = moment(workAuth.IssueDate).format('MM/DD/YYYY')=="01/01/0001" || moment(workAuth.IssueDate).format('MM/DD/YYYY')=="Invalid date"? '': moment(workAuth.IssueDate).format('MM/DD/YYYY');
                                    element.workAuthorization.validTo.date = moment(workAuth.ExpiryDate).format('MM/DD/YYYY')=="01/01/0001" || moment(workAuth.ExpiryDate).format('MM/DD/YYYY')=="Invalid date"?'':moment(workAuth.ExpiryDate).format('MM/DD/YYYY');
                                   
                                }
                              }
                              else
                              {
                                    element.workAuthorization.status ='';
                                    element.workAuthorization.checkListStatus ='';
                                    element.workAuthorization.documentNumber = '';
                                    element.workAuthorization.petitionFiledDate.date = '';
                                    element.workAuthorization.validFrom.date = '';
                                    element.workAuthorization.validTo.date = '';
                                    element.workAuthorization.referenceId = '';
                                    element.workAuthorization.type = '';
                              }
                              var index = _that.completeFormI539List.findIndex(m=>m.id == element.id);
                              _that.completeFormI539List[index].workAuthorization = element.workAuthorization;
                            }
                        });
                    }
                })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI539.vue